import * as React from "react";

const BlackShoppingCart: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
                d="M5.625 16.875C6.24632 16.875 6.75 16.3713 6.75 15.75C6.75 15.1287 6.24632 14.625 5.625 14.625C5.00368 14.625 4.5 15.1287 4.5 15.75C4.5 16.3713 5.00368 16.875 5.625 16.875Z"
                fill="black"
            />
            <path
                d="M13.5 16.875C14.1213 16.875 14.625 16.3713 14.625 15.75C14.625 15.1287 14.1213 14.625 13.5 14.625C12.8787 14.625 12.375 15.1287 12.375 15.75C12.375 16.3713 12.8787 16.875 13.5 16.875Z"
                fill="black"
            />
            <path
                d="M15.75 3.93749H3.27375L2.8125 1.57499C2.7862 1.44602 2.71551 1.33036 2.61273 1.24814C2.50995 1.16592 2.38159 1.12234 2.25 1.12499H0V2.24999H1.78875L3.9375 13.05C3.9638 13.179 4.03449 13.2946 4.13727 13.3768C4.24005 13.4591 4.36841 13.5026 4.5 13.5H14.625V12.375H4.96125L4.5 10.125H14.625C14.755 10.1282 14.8821 10.0862 14.9847 10.0062C15.0873 9.9262 15.1589 9.81313 15.1875 9.68624L16.3125 4.62374C16.3314 4.54028 16.3309 4.45362 16.3112 4.37035C16.2915 4.28709 16.2531 4.20941 16.1989 4.14324C16.1446 4.07706 16.076 4.02414 15.9982 3.98848C15.9204 3.95283 15.8355 3.93539 15.75 3.93749ZM14.175 8.99999H4.28625L3.49875 5.06249H15.0469L14.175 8.99999Z"
                fill="black"
            />
        </svg>

    );
};

export default React.memo(BlackShoppingCart);
